module.exports = " <article class=markdown-body v-html=\"markdown | marked\"></article> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-docs/app/shared/components/AppMarkdown.vue
 ** module id = 257
 ** module chunks = 2
 **/